import axios from "axios";

const api = axios.create({
  // Same-origin relative base: works on apex, www, preview and any future alias — no CORS
  baseURL: "/api",
  withCredentials: true,
});

// In-memory cache for public GET content (5 min TTL) — avoids refetching
// categories/products/settings on every page navigation.
const cache = new Map();
const TTL = 5 * 60 * 1000;

const originalGet = api.get.bind(api);
api.get = (url, config) => {
  if (url.startsWith("/admin") || url.startsWith("/auth")) return originalGet(url, config);
  const hit = cache.get(url);
  if (hit && Date.now() - hit.t < TTL) {
    return Promise.resolve({ ...hit.res, data: hit.res.data });
  }
  return originalGet(url, config).then((res) => {
    cache.set(url, { t: Date.now(), res: { status: res.status, data: res.data, headers: res.headers } });
    return res;
  });
};

export const clearApiCache = () => cache.clear();

api.interceptors.request.use((config) => {
  const token = window.localStorage.getItem("stj_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
